import React from "react";
import { Box, Input, Text } from "@showitinc/showit-wc";
import styles from "./SiteSettingsModal.module.css";
import { initFormatter } from "../../../utils/PropertyFormatters";

const FB_APP_ID = "fbAppId";

const FacebookAppId = ({ siteSettings, onChange }) => {
  const fbAppId = siteSettings.getIn(["config", FB_APP_ID], "");
  const { onChange: _onChange } = initFormatter(onChange);
  return (
    <>
      <Box mb="3">
        <Box p="3">
          <Text variant="heading-1">Facebook App ID</Text>
        </Box>
      </Box>
      <Box mb="2">
        <Input
          className={styles["text-field"]}
          bordered
          type="text"
          propName={`config.${FB_APP_ID}`}
          label="Facebook App ID"
          value={fbAppId}
          onSIChange={_onChange(`config.${FB_APP_ID}`)}
          placeholder="XXXXXXXXX"
          longLabel
        />
      </Box>
    </>
  );
};

export default FacebookAppId;
